import get from 'lodash/get';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import * as ListingBffRepository from './listingBffRepository';

export const ENTIRE_STATE = 'the entire state';
export const ENTIRE_COUNTRY = 'all of Australia';

const rollUpLocality = (localities = []) => {
  const states = localities.map(locality => locality?.subdivision);
  const uniqueStates = uniq(states);

  return uniqueStates?.length === 1
    ? uniqueStates[0]
    : undefined;
};

const mergeResults = (initialListings = [], secondaryListings = []) => {
  const markedSecondaryResults = secondaryListings.map(listing => ({
    ...listing,
    secondaryResult: true,
  }));
  const listings = initialListings.concat(markedSecondaryResults);

  return uniqBy(listings, listing => listing.id);
};

export const requestSecondaryResults = async (
  initialQuery,
  initialResponse,
  bff = ListingBffRepository,
) => {
  const upperLocality = rollUpLocality(initialQuery.localities);
  const localities = upperLocality
    ? [{ locality: upperLocality }]
    : undefined;
  const secondaryLocalityText = upperLocality
    ? ENTIRE_STATE
    : ENTIRE_COUNTRY;
  const secondaryResult = await bff.searchInvestListings({
    ...initialQuery,
    localities,
  });

  return ({
    listings: mergeResults(initialResponse.listings, secondaryResult.listings),
    availableResults: initialResponse.availableResults,
    secondaryLocalityText,
    resolvedLocations: initialResponse.resolvedLocations,
  });
};

export const temporaryLowResultsTreatmentForQuery = (
  initialQuery,
  performSecondaryRequest = requestSecondaryResults,
) => (
  initialResponse,
) => {
  const hasEnoughResults = initialResponse.availableResults > 2;
  const isLocalitySearch = get(initialQuery.localities, 'length', 0);
  // Determine if another search is required
  const listingData = (hasEnoughResults || !isLocalitySearch)
    ? initialResponse
    : performSecondaryRequest(initialQuery, initialResponse);

  return listingData;
};

const formatKeywords = (keywords = '') => {
  // Existing bug when entering in keywords
  const keywordsWithoutDoubleCommas = keywords.replace(',,', ',');
  const keywordsWithoutSpaces = keywordsWithoutDoubleCommas.replace(' ', '');

  return keywordsWithoutSpaces;
};

export const formatQuery = (query = {}) => {
  const keywords = get(query, 'filters.keywords');
  if (!keywords) return query;

  return {
    ...query,
    filters: {
      ...query.filters,
      keywords: formatKeywords(keywords),
    },
  };
};

export default (
  searchConditionQuery,
  featureFlags,
  bff = ListingBffRepository,
) => {
  const formattedQuery = formatQuery(searchConditionQuery);

  return bff.searchInvestListings(formattedQuery, featureFlags)
    .then(temporaryLowResultsTreatmentForQuery(formattedQuery))
    .catch(e => Promise.reject(e));
};
